import { Upload, Button, message, Image, Divider, Empty, Flex } from "antd";
import { UploadOutlined, DeleteOutlined, FileImageOutlined } from '@ant-design/icons';
import { useContext, useEffect, useState } from "react";
import { fetchImage } from "../../../utils/fetch";
import { LanguageContext } from "../../../utils/lang_provider";

export default function UploadWidget({ type, object }) {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const { language } = useContext(LanguageContext);
  const [thumbnail, setThumbnail] = useState(null);

  useEffect(() => {
    async function fetchThumbnail() {
        if (!object?.id) return;
        try {
        const response = await fetchImage(`front/image/${type}/${object.id}/thumbnail.png`, language, { size: "thumbnail" });

        if (!response.ok) {
            setThumbnail(null);
            return;
        }

        const blob = await response.blob();

        if (blob.size === 0) {
            setThumbnail(null);
            return;
        }

        const url = URL.createObjectURL(blob);
        setThumbnail(url);
        } catch {
        setThumbnail(null);
        }
    }

    fetchThumbnail();
    }, [type, object, language]);

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG files!');
      return Upload.LIST_IGNORE;
    }

    const isLt1M = file.size / 1024 / 1024 < 1;
    if (!isLt1M) {
      message.error('Image must be smaller than 1MB!');
      return Upload.LIST_IGNORE;
    }

    return true;
  };

  const handleChange = ({ file }) => {
    if (file.status === 'done') {
      message.success('Image uploaded successfully');
      setThumbnail(null);
      setTimeout(() => {
        fetchImage(`front/image/${type}/${object.id}/thumbnail.png`, language, { size: "thumbnail" })
          .then(res => res.blob())
          .then(blob => {
            const url = URL.createObjectURL(blob);
            setThumbnail(url);
          });
      }, 500);
    } else if (file.status === 'error') {
      message.error('Upload failed');
    }
  };

  const handleRemove = async () => {
    try {
      await fetch(`${backendUrl}/admin/content/update/${type}/image/${object?.id}/thumbnail`, {
        method: "DELETE",
        headers: { "Accept-Language": language.id },
      });
      message.success("Image removed");
      setThumbnail(null);
    } catch {
      message.error("Failed to remove image");
    }
  };

  return (
    <>
    <Flex gap={10} align="start" vertical wrap="wrap" style={{ marginTop: "10px" }}>
      <Divider orientation="left"><FileImageOutlined></FileImageOutlined> Thumbnail</Divider>
      {thumbnail ? (
        <div style={{ position: "relative", display: "inline-block" }}>
          <Image src={thumbnail} width={200} style={{ borderRadius: 8 }} />
          <Button
            type="primary"
            danger
            icon={<DeleteOutlined />}
            onClick={handleRemove}
            style={{
              position: "absolute",
              top: 5,
              right: 5,
              padding: "2px 6px",
              fontSize: 12,
            }}
            />
        </div>
      ) : (
        <>
        <Empty description="No thumbnail"></Empty>
        <Upload
          name="file"
          showUploadList={false}
          action={`${backendUrl}/admin/content/update/${type}/image/${object?.id}/thumbnail`}
          beforeUpload={beforeUpload}
          onChange={handleChange}
          headers={{
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }}
          >
          <Button icon={<UploadOutlined />}>Upload Thumbnail</Button>
        </Upload>
        </>
      )}
    </Flex>
    </>
  );
}
